import useTrans from '../../../../hooks/ui/useTrans';
import AppliedCouponCode from '../../../../types/AppliedCouponCode';
import Button from '../../../Button/Button';
import CleanButton from '../../../CleanButton/CleanButton';
import CouponTypeLabel from '../../../CouponTypeLabel/CouponTypeLabel';
import HiddenField from '../../../HiddenField/HiddenField';
import Row from '../../../Row/Row';
import Stack from '../../../Stack/Stack';
import Text from '../../../Text/Text';
import Title from '../../../Title/Title';

type CouponAppliedDialogProps = {
    trans: ReturnType<typeof useTrans>;
    coupon: AppliedCouponCode;
    currencyCode: string;
    onUndo: () => void;
    onClose: () => void;
};

const CouponAppliedDialog = ({
    trans,
    coupon,
    currencyCode,
    onUndo,
    onClose,
}: CouponAppliedDialogProps) => {
    return (
        <Stack>
            <Stack space="none">
                <Title variant="area" align="center">
                    {trans('CouponAppliedDialog.Title')}
                </Title>

                <Row horizontal="center">
                    <HiddenField name="couponCode" value="" />
                    <CleanButton type="submit" onClick={onUndo}>
                        <Text subdued underline>
                            {trans('CouponAppliedDialog.DetachButton')}
                        </Text>
                    </CleanButton>
                </Row>
            </Stack>

            <CouponTypeLabel
                coupon={coupon}
                currencyCode={currencyCode}
                bold
                align="center"
                tag="p"
            />

            <Row horizontal="center">
                <Button onClick={onClose}>
                    {trans('CouponAppliedDialog.CloseButton')}
                </Button>
            </Row>
        </Stack>
    );
};

export default CouponAppliedDialog;
